module.exports = __webpack_public_path__ + "img/s3.29460fde.png";